import React, { useEffect } from "react";
import AudienceByCountryChart from "./AudienceByCountryChart";
import NoData from "../NoData/NoData";
import Loading from "../Loading/Loading";

function AudienceByCountry(props) {
    const chartLoading = props.chartDataLoading?.audience_metrics_by_country;
    const isNoData =
        props.pageStatus ||
        Object.keys(props.chartData?.audience_metrics_by_country || {}).length === 0 ||
        props.chartData?.audience_metrics_by_country?.LocationWithData.length === 0;

    useEffect(() => {
        props.setIsNoDataState(isNoData);
    }, [props.chartData, props.pageStatus]);

    const emptyObject = () => {
        const chartData = props.chartData?.audience_metrics_by_country || {};
        const chartDataLength = Object.keys(chartData).length === 0;
        return isNoData || chartDataLength;
    };

    return (
        <>
            {chartLoading && <Loading />}
            {!emptyObject() && !chartLoading && (
                <AudienceByCountryChart
                    chartData={props.chartData.audience_metrics_by_country}
                    graphType={props.graphType}
                    showLegend={props.showLegend}
                    showGridLines={props.showGridLines}
                    showLabel={props.showLabel}
                    isIGPage={props.isIGPage}
                    widgetContainerRef={props.widgetContainerRef}
                />
            )}
            {emptyObject() && !chartLoading && <NoData message={props.pageStatus ? "Page is Inactive. Please re-authenticate" : ""} />}
        </>
    );
}

export default AudienceByCountry;
